'use client';

import {
  memo, useEffect, useMemo, useState,
} from 'react';

import { Link } from '@heroui/react';
import { LuArrowRightToLine } from 'react-icons/lu';

import { v4 as uuidv4 } from 'uuid';

import CarouselSkeleton from '@/features/v2/home/components/HeaderPublic/components/CarouselSkeleton';
import core from '@/features/v2/home/components/localization/core';

import DecorativeCard from '@/stories/molecules/cards/decorativeCard/DecorativeCard';

import { Carousel, CarouselContent } from '@/components/ui/carousel';

const PromotionsCarousel = memo(() => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => { return clearTimeout(timer); };
  }, []);

  const carouselItems = useMemo(() => {
    return core.public.carousel.map((item) => {
      return (
        <DecorativeCard
          key={uuidv4()}
          content={(
            <div>
              <h3 className="text-hforeground font-title text-base xl:text-lg font-black">{item.title}</h3>
              <p className="text-hforeground mt-2 font-text text-sm  leading-none w-3/5 lg:leading-tight">{item.description}</p>
              <Link
                href={item.link}
                className="flex items-center bg-gradient-to-t from-hgradient-50 to-hgradient-100 text-transparent bg-clip-text font-text text-xs lg:text-base mt-2 pointer-events-none"
                aria-label={`${item.textLink} sobre ${item.title}`}
              >
                <span className="bg-gradient-to-t from-hgradient-50 to-hgradient-100 text-transparent bg-clip-text">
                  {item.textLink}
                </span>
                <LuArrowRightToLine className="ml-2 text-hgradient-100" />
              </Link>
            </div>
          )}
          img={item.img}
          imgRotate="none"
          comingSoon
        />
      );
    });
  }, []);

  if (isLoading) {
    return <CarouselSkeleton />;
  }

  return (
    <div className="w-full ps-2">
      <Carousel
        className="w-full md:max-w-8xl mt-3 z-10 -4 md:flex md:justify-center"
        opts={{
          align: 'start',
          dragFree: true,
          containScroll: 'trimSnaps',
          startIndex: 0,
          duration: 500,
          active: true,
        }}
      >
        <CarouselContent className="ml-4 gap-2 lg:gap-5">
          {carouselItems}
        </CarouselContent>
      </Carousel>
    </div>
  );
});

export default PromotionsCarousel;
